import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters';
import 'amfe-flexible'
import { Button, Field, Tabbar, TabbarItem, Search, NavBar, Popup, Pagination, Dialog,Toast,Cell, CellGroup,PullRefresh,List,Loading } from 'vant'

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import 'swiper/dist/css/swiper.css'

// Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.use(Button).use(Field).use(Tabbar).use(TabbarItem).use(Search).use(NavBar).use(Popup).use(Pagination).use(Dialog).use(Toast).use(PullRefresh).use(List).use(Loading)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
